/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { InformacionImpresionPagoPrestamoModeloMLS } from './informacionImpresionPagoPrestamoModeloMLS';

export interface ObtenerInformacionImpresionPagoPrestamoMS { 
    nombreCooperativa?: string;
    numeroPrestamo?: string;
    oficina?: string;
    oficial?: string;
    tipo?: string;
    estado?: string;
    adjudicado?: string;
    ultimoPago?: string;
    proximoVencimiento?: string;
    movimientosReporte?: Array<InformacionImpresionPagoPrestamoModeloMLS>;
    valorCancelar?: number;
    valorAlDia?: number;
    hastaCuotaActual?: number;
    deudaInicial?: number;
    saldoActual?: number;
}